import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[maxLen]',
})
export class MaxLengthInputDirective {
  @Input() len = null;
  constructor(private el: ElementRef, public model: NgControl) {}
  @HostListener('input', ['$event'])
  onEvent($event) {
    let val = this.el.nativeElement.value;
    if (this.len && val.length > this.len) {
      val = val.slice(0, +this.len);
    }
    this.model.control.setValue(val);
  }
}
